import React, { Component } from 'react'
import { imageAddress } from '../../../../utils/useful'
import Responsive from '../../../Responsive'

export default class VideoMedia extends Component {
    state = {
        media: {}
    }
    componentDidMount() {
        this.props.filterMedia('video')
    }
    render() {
        return (
            <div className="w-100 h-100 scroll-no-scrollbar">
                <div className="d-flex flex-wrap m-0 w-100 p-2 h-100">
                    {this.props.media?.video?.map((element) => {
                        return (
                            <Responsive className={'px-1'} width={this.props.width} media={{ xs: "4", }}>
                                <div className='poistion-relative flexcc cursor-pointer '>
                                    <video className=' w-100 br-10 ' style={{ objectFit: " cover ", aspectRatio: ' 1/1 ', }} src={imageAddress(element.video)} poster={imageAddress(element.video.cover, 'video')} />
                                    <div className='position-absolute flexcc play-btn-bg br-50' >
                                        <img src='/assets/icons/play-white.svg' />
                                    </div>
                                </div>
                            </Responsive>
                        )
                    })}
                </div>
            </div>
        )
    }
}
